(function ($) {
    $(document).ready(function () {
        if ($('#form-create-change-request').length) {
            grecaptcha.ready(function() {
                grecaptcha.execute(rissb_var.recaptcha_site_key, {action: 'user_form'}).then(function(token) {
                    $('[name="recaptcha_token"]').val(token);
                });
            });

            $('[name="suggested_solutions"], [name="benefits_of_proposed_change"], [name="change_required"]').on('change', function () {
                grecaptcha.ready(function() {
                    grecaptcha.execute(rissb_var.recaptcha_site_key, {action: 'user_form'}).then(function(token) {
                        $('[name="recaptcha_token"]').val(token);
                    });
                });
            });

            $('[name="cr_type_of_change[]"]').on('change', function () {
                var checked = $('input[name="cr_type_of_change[]"]:checked').map(function () {
                    return $(this).val();
                }).get();

                $('.form-group-type-of-change-other').toggleClass('d-none', $.inArray('other', checked) === -1);
            });

            var $changeRequestForm = RISSB.fn.ajaxForm({
                form: '#form-create-change-request',
                clearForm: false,
                beforeSubmitCb: function () {
                    RISSB.fn.clearAlert();
                },
            });
        }
    });
})(jQuery);

